/**
 * confirmDialog — imperatywne API dla Terroir-styled potwierdzenia (zamiast window.confirm).
 *
 * Provider rejestruje się w window.__terroirConfirm (patrz components/ConfirmDialog.jsx).
 *
 * Użycie:
 *   import { confirmDialog } from '../lib/confirm';
 *
 *   if (await confirmDialog('Usunąć zadanie?')) {
 *     // user kliknął OK
 *   }
 *
 *   if (await confirmDialog('To jest nieodwracalne.', {
 *     title: 'Usuń konto?',
 *     confirmLabel: 'Usuń konto',
 *     tone: 'danger',
 *   })) { ... }
 *
 * Fallback: jeśli provider nie jest zamontowany (np. SSR / wczesny render),
 * używamy natywnego window.confirm() jako fallback.
 */

export function confirmDialog(messageOrOpts, opts) {
  if (typeof window === 'undefined') return Promise.resolve(false);
  const api = window.__terroirConfirm;
  if (api && typeof api.show === 'function') {
    if (typeof messageOrOpts === 'string') {
      return api.show({ ...(opts || {}), message: messageOrOpts });
    }
    return api.show(messageOrOpts);
  }
  // Fallback: window.confirm
  const msg = typeof messageOrOpts === 'string'
    ? messageOrOpts
    : (messageOrOpts?.message || messageOrOpts?.title || '');
  // eslint-disable-next-line no-alert
  return Promise.resolve(window.confirm(msg));
}
